
const lbaCompanyReference = angular.module('app.lbaCompanyReference', [
 require('../lbaGrid').name,
 require('../lbaCompanyReferenceItemForm/lbaCompanyReferenceItemForm').name,
 require('../lbaCompanyReferenceGrid/lbaCompanyReferenceGrid').name
]);

lbaCompanyReference.controller('lbaCompanyReferenceCtrl', require('./lbaCompanyReferenceCtrl'));
lbaCompanyReference.directive('lbaCompanyReference', require('./lbaCompanyReferenceDir'));
lbaCompanyReference.service('companyReferenceService', require('../../services/companyReferenceService'));


export default lbaCompanyReference;




// WEBPACK FOOTER //
// ./src/components/lbaCompanyReference/index.js